import React from 'react';
import Immutable from 'immutable';

import {
	Button,
	Form,
	FormItem,
	REPORTED_EXCEPTION,
	TextInput,
	showMessageBox,
	webapi,
} from 'ps-gui';
import { Dialog, DialogButtons, DialogContent, DialogHeader, DialogSubtext } from '../../components/dialog';
import { getFormItemLabel, getPhrase } from '../../data/phrases';
import { Label } from '../submissioncomponents';
import UploadPane from '../../components/uploadpane';
import { downloadFile, formatFileSize } from '../utils';
import FileList from '../../components/filelist';


const EMPTY_LIST = Immutable.List([]);
const fileSizeLimit = 20 * 1024 * 1024;

export class UnlockDialog extends React.PureComponent {
	constructor() {
		super();
		this.setComments = this.setComments.bind(this);
		this.deleteAttachment = this.deleteAttachment.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.onOk = this.onOk.bind(this);
		this.onFileUploadRequested = this.onFileUploadRequested.bind(this);
		this.downloadFile = this.downloadFile.bind(this);
	}

	async onFileUploadRequested(files) {
		if (!files || files.length === 0) {
			return;
		}
		let newFileSizeSum = 0;
		for (let i = 0; i < files.length; i++) {
			const file = files[i];
			newFileSizeSum += file.size;
		}

		if (newFileSizeSum  > fileSizeLimit) {
			showMessageBox(getPhrase('fileSizeSumLimitExceeded').replace('$limit', formatFileSize(fileSizeLimit).replace('$size', formatFileSize(newFileSizeSum))));
			return;
		}

		let newFiles = [];
		for (let i = 0; i < files.length; i++) {
			const file = files[i];
			const uploadedFile = await webapi.upload('/api/file', file);
			if (uploadedFile === REPORTED_EXCEPTION) {
				continue;
			}
			newFiles.push(Object.assign({
				size: file.size,
				fileName: uploadedFile.originalFileName
			}, uploadedFile));
		}
		this.addAttachment(Immutable.fromJS(newFiles));
	}


	async downloadFile(file) {
		const uf = await webapi.execute('/api/affirmation/getAttachmentDownloadInfo', {
			fileId: file.get('fileId')
		});
		if (uf === REPORTED_EXCEPTION) {
			return;
		}
		downloadFile(uf.fileId, uf.originalFileName);
	}

	renderFiles(files) {
		const readOnly = this.props.readOnly;
		return (
			<FileList
				files={files}
				onDownloadRequested={this.downloadFile}
				onDeleteRequested={readOnly ? null : (file, index) => {
					this.deleteAttachment(file.get('fileId'));
				}}
			/>
		);
	}

	onOk() {
		if (this.props.optional) {
			this.props.onOk();
			return;
		}
		const comments = this.getData().get('comments');
		if (!((comments || '').replace(/\s/g, ''))) {
			showMessageBox('Vyplňte zdůvodnění opravy/doplnění.');
			return;
		}
		this.props.onOk();
	}

	onCancel() {
		this.props.onCancel();
	}

	getData() {
		return this.props.data;
	}

	setData(data) {
		this.props.setData(data);
	}

	setComments(value) {
		this.setData(this.getData().set('comments', value));
	}

	deleteAttachment(fileId) {
		const data = this.getData();
		const attachments = data.get('attachments') || EMPTY_LIST;
		const idx = attachments.findIndex(f => f.get('fileId') === fileId);
		if (idx < 0) {
			return;
		}
		const delPath = [idx, '_deleted'];
		this.setData(data.set('attachments', attachments.setIn(delPath, !attachments.getIn([idx, '_deleted']))));
	}

	addAttachment(newFiles) {
		const data = this.getData();
		const attachments = data.get('attachments') || EMPTY_LIST;
		this.setData(data.set('attachments', attachments.concat(newFiles)));
	}

	render() {
		const data = this.getData();
		return (
			<Dialog onCloseRequested={this.onCancel}>
				<DialogHeader marginBottom="16px">{this.props.header || getPhrase('correctionAddition')}</DialogHeader>
				{
					!this.props.readOnly && !this.props.noSubtext && (
						<DialogSubtext marginBottom="16px">{getPhrase('affirmationCorrectionSubheader')}</DialogSubtext>
					)
				}
				<DialogContent>
					<Form>
						<FormItem label={getFormItemLabel('correctionReason')}>
							<TextInput
								value={data.get('comments')}
								onChange={this.setComments}
								readOnly={this.props.readOnly}
								// placeholder={getPhrase('attachANoteOrAFile')}
								multiline
								changeOnBlur
								maxLength="1000"
								minHeight="100px"
							/>
						</FormItem>
						{
							!this.props.noAttachments && (
								<>
									<Label>
										{getFormItemLabel('attachments', 'submission')}
										{!this.props.readOnly && (<span className='hint'>({getPhrase('maxSize')} 20 MB)</span>)}
									</Label>
									{
										!this.props.readOnly && (
											<>
												<UploadPane
													onFileUploadRequested={this.onFileUploadRequested}
													buttonText={getPhrase('selectAttachment')}
													dragText={getPhrase('dragFileOrFiles')}
													marginBottom="24px"
												/>
											</>
										)
									}
								</>
							)
						}
						{
							this.renderFiles(data.get('attachments'))
						}
					</Form>
				</DialogContent>
				<DialogButtons className="right">
					{
						this.props.readOnly ? (
							<Button
								text={getPhrase('close')}
								minWidth="120px"
								type="medium"
								onAction={this.onCancel}
							/>
						) : (
							<>
								<Button
									text={getPhrase('cancel')}
									minWidth="120px"
									type="medium"
									onAction={this.onCancel}
								/>
								<Button
									text={getPhrase('ok')}
									minWidth="120px"
									onAction={this.onOk}
								/>
							</>
						)
					}
				</DialogButtons>
			</Dialog>
		);
	}
}
